import { render, staticRenderFns } from "./WaitingForUser.vue?vue&type=template&id=0338d650&"
import script from "./WaitingForUser.vue?vue&type=script&lang=js&"
export * from "./WaitingForUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports